
import { t } from "i18next";
import { MESSAGE_BAR_TYPES } from "../../utils/constants";
import { fiatWithdraw, getBusinessFieldValues, getFiatBankForm, getFiatBanks, getFiatWithdrawFees, getPersonalFields, } from "../api";
import { CLEAR_BANK_FORMDATA, CONNECT_BANK, GET_CONNECTED_BANKS, GET_COUNTRY, GET_POCKYT_BANK_FORM_DATA, GET_POCKYT_FEES, REPLACE_BANK, SET_FORM_VALUES, SET_LAST_REFRENCE_ID, SHOW_MESSAGE } from "./actionTypes";

export const getCountriesData = () => async (dispatch) => {
  try {
    const response = null;
    await dispatch({
      type: GET_COUNTRY,
      payload: response.result,
    });
  } catch (err) {
    dispatch({
      type: SHOW_MESSAGE,
      payload: {
        type: MESSAGE_BAR_TYPES.ERROR,
        message: err?.response?.data?.message || err.message
      }
    });
  }
};

export const setLastRefId = (payload) => dispatch => {
  dispatch({
    type: SET_LAST_REFRENCE_ID,
    payload
  })
}

export const getPockytConnectedBanks = () => async (dispatch) => {
  try {
    const response = await getFiatBanks();
    await dispatch({
      type: GET_CONNECTED_BANKS,
      payload: response.result,
    });
  } catch (err) {
    dispatch({
      type: SHOW_MESSAGE,
      payload: {
        type: MESSAGE_BAR_TYPES.ERROR,
        message: err?.response?.data?.message || err.message
      }
    });
  }
}

export const connectBank = (payload) => async (dispatch) => {
  await dispatch({
    type: CONNECT_BANK,
    payload,
  });
}

export const getPockytBankFormData = (currency, country, destinationRecordId, onSuccess, onFailure) => async (dispatch) => {
  try {
    const response = await getFiatBankForm(currency, country, destinationRecordId);
    const response2 = await getPersonalFields();
    const formData = response.result;
    const values = response2?.result?.fields;
    const allValues = Object.keys(values);
    let form = {};
    Object.keys(formData).forEach((key) => {
       form[key] = formData[key].map(v => {
        if(allValues.indexOf(v.name) > -1) {
          v.acceptedValues = values[v.name];
        }
        return v;
       })
    })
    await dispatch({
      type: GET_POCKYT_BANK_FORM_DATA,
      payload: form,
    });
    if (typeof onSuccess === 'function') onSuccess();
  } catch (err) {
    if (typeof onFailure === 'function') onFailure(err);
    // dispatch({
    //   type: SHOW_MESSAGE,
    //   payload: {
    //     type: MESSAGE_BAR_TYPES.ERROR,
    //     message: err?.response?.data?.message || err.message
    //   }
    // });
  }
}

export const getPockytFees = (payload,currency, country, isConflict) => async (dispatch) => {
  try {
    const response = await getFiatWithdrawFees(payload, currency, country);
    if (response?.result?.error) {
      dispatch({
        type: SHOW_MESSAGE,
        payload: {
          type: MESSAGE_BAR_TYPES.ERROR,
          message: response?.result?.message || t('transferFailed')
        }
      });
    }
    await dispatch({
      type: GET_POCKYT_FEES,
      payload: response.result,
    });
  } catch (err) {
    if (err?.response?.data?.data?.isConflict && typeof isConflict === 'function') isConflict(true);
    else
      dispatch({
        type: SHOW_MESSAGE,
        payload: {
          type: MESSAGE_BAR_TYPES.ERROR,
          message: err?.response?.data?.message || err.message
        }
      });
  }
}
export const pockytFiatWithdraw = (payload) => async (dispatch) => {
  try {
    const response = await fiatWithdraw(payload);
    return response.result;
  } catch (err) {
    dispatch({
      type: SHOW_MESSAGE,
      payload: {
        type: MESSAGE_BAR_TYPES.ERROR,
        message: err?.response?.data?.message || err.message
      }
    });
  }
}

export const replaceBankDetails = (payload) => async (dispatch) => {
  await dispatch({
    type: REPLACE_BANK,
    payload,
  });
}
export const clearPockytFees = (payload) => async (dispatch) => {
  await dispatch({
    type: GET_POCKYT_FEES,
    payload: {},
  });
}

export const clearBankForm = () => async (dispatch) => {
  await dispatch({
    type: CLEAR_BANK_FORMDATA
  });
}

export const getFormValues = () => async (dispatch) => {
  try {
    const response = await getBusinessFieldValues();
    dispatch({
      type: SET_FORM_VALUES,
      payload: response.result || {}
    })
  }catch(err) {
    // todo
  }
}